import { atomWithReset } from 'jotai/utils'

import {
  type Brand,
  type BrandGroup,
  type Question,
} from '~/hooks/useSurveyQuery'
import { type SurveyFilterGroups } from '~/utils'

import { type TabulationDataItem } from '../hooks/transformWhoAndWhatResult'

export const isTabulationReadyAtom = atomWithReset(false)
export const isTabulationFetchingAtom = atomWithReset(false)

export const tabulationDataAtom = atomWithReset<TabulationDataItem[] | null>(
  null,
)

export const whoAndWhatAwaitIdAtom = atomWithReset<string | null>(null)

export type TabulationParamsSnapshot = {
  brandGroupId: BrandGroup['id'] | null
  brandIds: Brand['id'][]
  npiDriverQuestionId: Question['question_id'] | null
  importanceQuestionId: Question['question_id'] | null
  liftSaQuestionId: Question['question_id'] | null
  surveyFilter: { count: number; filterGroups: SurveyFilterGroups } | null
}

export const lastTabulationParamsAtom =
  atomWithReset<TabulationParamsSnapshot | null>(null)
